const URL = {
  COURSE_STATISTICS_LIST: 'report/courseStatisticsByFilter',
}

export default URL
